<template>
	<button
		type="button"
		@click="$emit('click')"
		:style="`background-color:${color}`"
		:class="[
			'button-container',
			iconAfter ? 'img-after': 'img-before',
			{ 'img-center': !text },
		]"
	>
		<img
			:src="img"
			v-if="img"
		>
		<v-icon
			v-if="icon"
			:color="iconColor"
		>{{icon}}</v-icon>
		<span v-if="text">{{text}}</span>
	</button>
</template>

<script>

function color() {
	if (this.primary && !this.bgColor) {
		return this.$appColors.primary;
	}
	return this.bgColor;
}

export default {
	name: 'app-button',
	computed: {
		color,
	},
	props: {
		bgColor: {
			default: '',
			type: String,
		},
		img: {
			default: '',
			type: String,
		},
		icon: {
			default: '',
			type: String,
		},
		iconAfter: {
			default: false,
			type: Boolean,
		},
		iconColor: {
			default: 'white',
			type: String,
		},
		primary: {
			type: Boolean,
			default: true,
		},
		text: {
			default: '',
			type: String,
		},
	},
};
</script>

<style lang="scss" scoped>
.button-container {
	align-items: center;
	display: flex;
	justify-content: flex-start;
	transition: all 250ms ease-in;

	&.img-center {
		justify-content: center;
	}

	&.img-after {
		flex-direction: row-reverse;
	}

	&.img-before {
		flex-direction: row;
	}

	&:hover {
		filter: brightness(1.2);
	}

	&:active {
		transform: scale(0.95, 0.98);
	}
	&[disabled] {
		background-color: color(gray-medium) !important;
		cursor: not-allowed;
		opacity: 0.4;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/shared/app-button.vue